import { AwardingClient } from "@/utils/EvoClient";
import { waitForXBeforeResolve } from "@/utils/functions";
import { MoveSectionToPosition } from "../dto";

const ENDPOINT = "c/move-section";

export default function MoveSection(dto: MoveSectionToPosition): Promise<void> {
  return waitForXBeforeResolve<void>(AwardingClient.post(ENDPOINT, dto), 500); //warte auf Verschiebeanimationsende
}
